export default "__VITE_ASSET__ocRJsOM___"